
    import { mapActions } from 'vuex';

    export default {
        name: 'JobViewSplash',

        data() {
            return {};
        },

        mounted() {
            const body = document.getElementsByTagName('body')[0];
            body.style.overflow = 'hidden';

            setTimeout(() => {
                this.$emit('destroy');
            }, 5000);
        },

        beforeDestroy() {
            const body = document.getElementsByTagName('body')[0];
            body.style.overflow = '';
        },

        methods: {
            ...mapActions('me', {
                $_pushToOnboarding: 'pushToOnboarding',
            }),
        },
    };
